// dependencies
import React from "react";

// icons
import { faLock } from "@performyard/fontawesome/pro-solid-svg-icons";

// components
import { Divider } from "../../../../../../../../../components/Divider";
import Icon from "../../../../../../../../../components/Icon/Icon";
import Typography from "../../../../../../../../../components/Text";
import GoalListEntry from "./GoalListEntry";

// services
import { Goal, RedactedGoal } from "../../../../../../../../../api/services";

// styles
import css from "./GoalList.module.scss";

type GoalListProps = {
	goals: Goal[];
	privateGoals?: RedactedGoal[];
	/** Name of the goal whose page is listing these related goals — carried as the breadcrumb `fromLabel`. */
	currentGoalName?: string;
};

const PrivateGoalEntry = () => (
	<div className={css.goalListItem}>
		<div className="flex h-[30px] w-[30px] items-center justify-center rounded-full bg-neutral-7">
			<Icon icon={faLock} size={14} color="neutral-1" />
		</div>
		<div className={css.goalDetails}>
			<Typography size="paragraph-3" weight="semi-bold" color="neutral-7">
				Private Goal
			</Typography>
		</div>
	</div>
);

const GoalList = ({ goals, privateGoals = [], currentGoalName }: GoalListProps) => {
	const totalItems = goals.length + privateGoals.length;

	return (
		<div className={css.goalList}>
			{goals.map((goal, index) => {
				const shouldHaveDivider = index !== totalItems - 1;
				return (
					<div key={goal._id} className={css.goalListItemContainer}>
						<GoalListEntry goal={goal} currentGoalName={currentGoalName} />
						{shouldHaveDivider && <Divider />}
					</div>
				);
			})}
			{privateGoals.map((privateGoal, index) => {
				const isLast = index === privateGoals.length - 1;
				return (
					<div key={privateGoal._id} className={css.goalListItemContainer}>
						<PrivateGoalEntry />
						{!isLast && <Divider />}
					</div>
				);
			})}
		</div>
	);
};

export default GoalList;
